import React from 'react';
import { Table } from 'antd';
import './organization.css';
import PropTypes from 'prop-types';

const OrganizationGrid = ({ columns, csvArray }) => {
  return (
    <Table
      columns={columns}
      dataSource={csvArray.map((item, i) => ({
        key: i, 
        organization_id: item.organizationId,
        organization_name: item.organizationName,
        owner_identity: item.ownerIdentity,
        additional_admin: item.additionalAdminAccount == null || item.additionalAdminAccount.length == 0 ? '-' : item.additionalAdminAccount,
        is_organization_test: item.isOrganizationTest ? 'Yes' : 'No',
        hubspot_companyId: item.hubspotCompanyId  == null || item.hubspotCompanyId == "-1"  ? "-" : item.hubspotCompanyId,
        deal_id: item.dealId == null || item.dealId == "-1" ? "-" : item.dealId,
        plan: item.plan == null || item.plan == "-1" ? "-" : item.plan,
        Status: item.Status,
      }))}
      rowClassName={(record: { Status?: string }) =>
        !record.Status || record.Status.trim() === ''
          ? ''
          : record.Status.replace('\n', '').trim().includes('Tenant created successfully!')
          ? 'table-row-green'
          : record.Status.replace('\n', '').trim().includes("Warning: Couldn't release the contract view to the owner on Launchdarkly")
          ? 'table-row-yellow'
          : 'table-row-red'
      }
    />
  );
};

export { OrganizationGrid };

OrganizationGrid.propTypes = {
  columns: PropTypes.array,
  csvArray: PropTypes.array
}
